<div class="storage-dialog">

  <div class="storage-header" mat-dialog-title>
    <div class="storage-title">
      <mat-icon>inventory_2</mat-icon>
      <div>
        <h2>Almacenamiento</h2>
        <span class="storage-sub">{{ data.identifier || 'Equipo' }}</span>
      </div>
    </div>
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </div>

  <mat-dialog-content class="storage-body">

    <section class="storage-section">
      <h3 class="section-title"><mat-icon>thermostat</mat-icon> Condiciones de almacenamiento</h3>
      <div class="grid-2">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Temperatura (°C)</mat-label>
          <input matInput type="number" [(ngModel)]="storage_temp">
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Humedad relativa (%)</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="storage_humidity">
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="full-width">
        <mat-label>Notas / condiciones</mat-label>
        <textarea matInput rows="2" [(ngModel)]="storage_conditions"></textarea>
      </mat-form-field>
    </section>

    <section class="storage-section">
      <h3 class="section-title"><mat-icon>straighten</mat-icon> Dimensiones del equipo (cm)</h3>
      <div class="grid-3">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Largo</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="dim_length">
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Ancho</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="dim_width">
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Alto</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="dim_height">
        </mat-form-field>
      </div>
    </section>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()" [disabled]="saving()">Cancelar</button>
    <button mat-flat-button color="primary" (click)="save()" [disabled]="saving()">
      @if (saving()) {<mat-spinner diameter="18"></mat-spinner>} @else {<mat-icon>save</mat-icon>}
      <span>Guardar</span>
    </button>
  </mat-dialog-actions>

</div>
